import { Link } from "react-router-dom";
import { ArchWindow } from "../components/ArchWindow";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#FFF5F2] flex items-center justify-center px-6">
      <div className="glass rounded-2xl p-12 max-w-lg w-full text-center" data-testid="payment-cancel-card">
        <div className="flex justify-center"><ArchWindow size={44} /></div>
        <h1 className="font-orbitron font-bold text-xl text-[#120716] mt-8">GIFT CANCELLED</h1>
        <p className="mt-4 text-sm text-[#120716]/60 leading-relaxed">
          No charge was made. The work goes on, and the door is always open if you'd like to come back.
        </p>
        <blockquote className="mt-6 italic font-light text-[#C13B3B] text-sm">
          "The Lord bless you and keep you." — Numbers 6:24
        </blockquote>
        <Link to="/#donate" data-testid="cancel-back-home" className="inline-block mt-8 rounded-full border border-[#E84C4C]/40 text-[#120716] text-sm font-semibold px-8 py-3 hover:bg-[#E84C4C]/10 transition-all">
          Return to Donations
        </Link>
      </div>
    </div>
  );
}
